<template>
  <v-col cols="12" v-if="languageData && IsApexChartLoaded">
    <v-card>
      <v-card-title class="v-card-title">
        {{ languageData.labels.year_income }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-5 pt-0">
        <v-row no-gutters>
          <v-col cols="12">
            <ApexChart      
                type="area"
                height="350"
                :options="apexBar.options"
                :series="apexBar.series"
            ></ApexChart>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import ApexChart from 'vue-apexcharts'
import config from "../../../../../../template/config";
import {mapState} from 'vuex';

export default {
  name: "IncomeChart",
  components: {
    ApexChart
  },
  data() {
    return {
      apexBar: {
        series: [{
          name: 'Income',
          data: [],
        }],
        options: {
          chart: {
            type: 'bar',
            height: 350,
            toolbar: {
              show: false,
            },
          },
          colors: [config.light.primary],
          plotOptions: {
            bar: {
              borderRadius: 10,
              dataLabels: {
                position: 'top', // top, center, bottom
              },
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val;
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: [config.light.fontDefault]
            }
          },
          xaxis: {
            categories: [],
            position: 'top',
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            },
          },
        },
      },
      isApexBarLoaded: false
    };
  },
  watch: {
    dataLoaded(newValue) {
      if (newValue && !this.isApexBarLoaded) {
        this.prepareData();
      }
    }
  },
  computed: {
    ...mapState("getDashboardData", {
      yearIncome: state => state.yearIncome,
      dataLoaded: state => state.dataLoaded
    }),
    IsApexChartLoaded() {
      return this.isApexBarLoaded;
    },
  },
  methods: {
    prepareData() {
      for(let i = 0; i < 12; i++) {
        this.apexBar.options.xaxis.categories.push(this.languageData.months[i]);
        this.apexBar.series[0].data.push(0.00)
      }
      this.yearIncome.filter(el => {
        this.apexBar.series[0].data[el.month-1] = el.income_total_net;
      })

      this.isApexBarLoaded = true;
    },
  },
  mounted() {
    if (this.dataLoaded) {
      this.prepareData();
    }
  },
  updated() {
    if (this.dataLoaded && !this.isApexBarLoaded) {
      this.prepareData();
    }
  }

}
</script>

<style src="./IncomeChart.scss" lang="scss"></style>